module.exports = __webpack_public_path__ + "static/media/settings.46c25e72.svg";